import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { InformationCircleIcon } from '@calendly/ui/components/icons';
import classNames from 'classnames';
import { isEmpty } from 'lodash-es';
import { forwardRef } from 'react';
import { WidgetContainer } from './widget_container';
const contentsCss = "ccjqvdy";
const Contents = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(contentsCss, props.className)} />;
});
const nudgedInformationCircleIconCss = "n1igdhp1";
const NudgedInformationCircleIcon = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(nudgedInformationCircleIconCss, props.className)}>
      <InformationCircleIcon />
    </Component>;
});
export const InstructionsWidget = ({
  event
}) => {
  if (event.pendingType !== 'AdhocEventType' || isEmpty(event.description)) return null;
  return <WidgetContainer title={I18n.t('publisher.event_types.general.description')}>
      <Contents>
        <NudgedInformationCircleIcon />
        <div>
          {HtmlParser(event.description)}
        </div>
      </Contents>
    </WidgetContainer>;
};

require("./instructions_widget.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./instructions_widget.js");